import { Configuration } from "@azure/msal-browser";

const tenantName = `${process.env.VUE_APP_AZURE_AD_B2C_TENANT_NAME}.b2clogin.com`;
const authority = `https://${tenantName}/${process.env.VUE_APP_AZURE_AD_B2C_TENANT_NAME}.onmicrosoft.com`;

export const b2cPolicies = {
  names: {
    signUpSignIn: process.env.VUE_APP_SIGNIN_POLICY,
    forgotPassword: "B2C_1_reset_password",
  },
  authorities: {
    signUpSignIn: {
      authority: `${authority}/${process.env.VUE_APP_SIGNIN_POLICY}`,
    },
    forgotPassword: {
      authority: `${authority}/B2C_1_reset_password`,
    },
  },
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_AD_B2C_CLIENT_ID ?? "",
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
    knownAuthorities: [
      tenantName
    ]
  },
  cache: {
    cacheLocation: "localStorage"
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "offline_access"],
};

const apiConfig = {
  b2cScopes: [...loginRequest.scopes, "https://graph.microsoft.com/.default"],
};

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
  scopes: apiConfig.b2cScopes,
};
